<template>
  <v-card outlined class="d-flex flex-column" rounded="lg">
    <div class="banner-container">
      <v-img
        :src="artist.coverPhoto"
        height="200"
        class="rounded-t-lg"
      ></v-img>
      <div style="position: absolute; top: 10px; right: 10px">
        <v-btn color="primary" small @click="openDialog">
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
      </div>

      <v-avatar size="120" class="profile-photo">
        <v-img :src="artist.profilePhoto" cover></v-img>
      </v-avatar>
    </div>
    <v-card-text class="info-container d-flex flex-column flex-grow-1">
      <h3 class="text-center mb-0">{{ artist.name }}</h3>
      <p class="text-center mb-0">{{ artist.category }}</p>
      <v-spacer />
      <v-btn @click="viewArtist" text small color="primary">
        Ver página do artista <v-icon right>mdi-open-in-new</v-icon>
      </v-btn>
    </v-card-text>
    <EditArtistDialog
      :artist="artist"
      v-model="dialogOpen"
      @artist-saved="handleArtistSaved"
      @error="handleError"
    />
  </v-card>
</template>

<script>
import EditArtistDialog from "./ArtistDialog.vue";
export default {
  name: "ArtistCard",
  components: {
    EditArtistDialog,
  },
  props: {
    artist: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogOpen: false,
    };
  },
  methods: {
    openDialog() {
      this.dialogOpen = true;
    },
    viewArtist() {
      const baseUrl = "https://ticketme.app/artist";
      window.open(`${baseUrl}/${this.artist.slug}`, "_blank");
    },
    handleArtistSaved(updatedArtist) {
      this.$emit("artist-updated", updatedArtist);
    },
    handleError(error) {
      console.error(error);
    },
  },
};
</script>

<style scoped>
.banner-container {
  position: relative;
}

.profile-photo {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  border: 3px solid white;
}

.info-container {
  margin-top: 50px;
}
</style>
